// TitleManager.js

import { useEffect, useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ClipsPostsContext } from '../contexts/ClipsPostsContext';
import { LooksPostsContext } from '../contexts/LooksPostsContext';

/* --- static titles for simple routes --- */
const routeTitles = {
  '/': 'Looksaway',
  '/about': 'About',
  '/bulletin': 'Bulletin',
  '/categoryposts': 'Category Posts',
  '/clips-admin-dashboard': 'Admin Dashboard',
  '/clipscontactform': 'Contact Form',
  '/explore': 'Explore',
  '/forgot-password': 'Forgot Password',
  '/info': 'Info',
  '/login': 'Login',
  '/newposts': 'New Posts',
  '/signup': 'Sign Up',
  '/trending': 'Trending Posts',
  // add more fixed paths here if you need them
};

function TitleManager() {
  const location = useLocation();
  const { username, category } = useParams();

  /* ▸ These providers may or may not be mounted, so guard with ?. */
  const clipsCtx = useContext(ClipsPostsContext);
  const looksCtx = useContext(LooksPostsContext);

  const clipPosts  = clipsCtx?.posts  || [];
  const looksPosts = looksCtx?.posts || [];

  useEffect(() => {
    const path = location.pathname;

    /* ---------- LOOKS dynamic routes ---------- */
    if (path.startsWith('/looksusersposts/')) {
      document.title = username ? `${username}'s posts` : 'User posts';
      return;
    }

    if (path.startsWith('/looksposts/')) {
      const postId = path.split('/')[2];
      const post   = looksPosts.find((p) => p.id === postId);
      document.title = post?.title || 'Looksaway Post';
      return;
    }

    /* ---------- CLIPS dynamic routes (optional) ---------- */
    if (path.startsWith('/clipsusersposts/')) {
      document.title = username ? `${username}'s posts` : 'User posts';
      return;
    }

    if (path.startsWith('/clipsposts/')) {
      const postId = path.split('/')[2];
      const post   = clipPosts.find((p) => p.id === postId);
      document.title = post?.title || 'Looksaway Post';
      return;
    }

    /* ---------- Category & search pages ---------- */
    if (path.startsWith('/categoryposts/')) {
      document.title = category || 'Category Posts';
      return;
    }

    if (path.startsWith('/clipssearchresults')) {
      const query = new URLSearchParams(location.search).get('query');
      document.title = query ? `Search results for "${query}"` : 'Search results';
      return;
    }

    /* ---------- Fallback to static map ---------- */
    document.title = routeTitles[path] || 'Page Not Found';
  }, [location, looksPosts, clipPosts, username, category]);

  return null;
}

export default TitleManager;
